import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { finalize } from 'rxjs/operators'
import { LoaderService } from '../services/loader.service'

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
    static readonly DO_NOT_BLOCK_UI_HEADER = 'Do-Not-Block-Ui'

    constructor(private loaderService: LoaderService) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (!request.headers.has(LoaderInterceptor.DO_NOT_BLOCK_UI_HEADER)) {
            this.loaderService.block(request.urlWithParams)
        } else {
            request = request.clone({ headers: request.headers.delete(LoaderInterceptor.DO_NOT_BLOCK_UI_HEADER) })
        }
        return next.handle(request).pipe(finalize(() => this.loaderService.unblock(request.urlWithParams)))
    }
}
